import { Callout, type CalloutTone } from '@/components/ui/callout';

export type StatusType = 'error' | 'success' | 'loading' | 'info' | 'warning';

export interface StatusCardProps {
  /** The type of status to display */
  type: StatusType;
  /** The message to display */
  message: string;
  /** Optional title */
  title?: string;
  /** Additional CSS classes */
  className?: string;
  /** Whether to show the icon (default: true) */
  showIcon?: boolean;
}

const TONES: Record<StatusType, CalloutTone> = {
  error: 'error',
  success: 'success',
  loading: 'neutral',
  info: 'info',
  warning: 'warning',
};

/**
 * Status message (error, success, loading, info, warning). Kept for its callers; renders the
 * shared `Callout`.
 *
 * @example
 * <StatusCard type="error" message="Something went wrong" />
 * <StatusCard type="success" title="Success!" message="Operation completed" />
 * <StatusCard type="loading" message="Loading data..." />
 */
export function StatusCard({ type, message, title, className, showIcon = true }: StatusCardProps) {
  return (
    <Callout
      tone={TONES[type]}
      loading={type === 'loading'}
      title={title}
      icon={showIcon ? undefined : false}
      className={className}
    >
      {message}
    </Callout>
  );
}
